import { LastStatusBlockProps } from "./types";
import { LastStatusWeb } from "./web";

export function LastStatusWebEditor(props: LastStatusBlockProps) {
  return <LastStatusWeb {...props} />;
}
